/* eslint camelcase: 0 */

import { ParticipantsUsersCollection as Data } from '@/typings/api/Participant'
import { Model } from '@/helpers/Model'


export class ParticipantsUsersModel extends Model<Data> {
}
